// JobsPage.jsx
import React, { useState } from 'react';
import '../assets/css/JobsPage.css';
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";
import { useNavigate } from "react-router-dom";

// ---------- Import job data from separate file ----------
import { jobData } from "../components/jobData";

export default function JobsPage() {
  const navigate = useNavigate();

  // ------------------ Filters State ------------------
  const [categoryFilter, setCategoryFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [locationFilter, setLocationFilter] = useState("");

  // ------------------ Apply Filters ------------------
  const filteredJobs = jobData.filter(job => {
    return (
      (categoryFilter === "" || job.category === categoryFilter) &&
      (typeFilter === "" || job.type === typeFilter) &&
      (locationFilter === "" || job.location.includes(locationFilter))
    );
  });


  return (
    <>
      <BreadcrumbSection
        title="Redefining Healthcare with Precision and Passion."
        breadcrumbItems={[{ label: "Home", to: "/" }]}
        backgroundImage={BredcrumpImage}
      />

      <div className="jobs-container">
        <section className="jobs-wrapper">
          <h2 className="jobs-title">Recent Jobs Available</h2>
          <p className="jobs-subtitle"></p>

          {/* Filters */}
          <div className="filters-box">
            {/* Category Filter */}
            <div className="filter-item">
              <label>Search by Job Category</label>
              <select value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}>
                <option value="">All Categories</option>
                <option>Product Management Team</option>
                <option>Medical Representative</option>
                <option>Sales</option>
              </select>
            </div>

            {/* Job Type Filter */}
            <div className="filter-item">
              <label>Search by Job Type</label>
              <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
                <option value="">All Types</option>
                <option>Full time</option>
                <option>Part time</option>
                <option>Contract</option>
              </select>
            </div>

            {/* Location Filter */}
            <div className="filter-item">
              <label>Location</label>
              <select value={locationFilter} onChange={(e) => setLocationFilter(e.target.value)}>
                <option value="">All Job Location</option>
                <option>Andhra Pradesh</option>
                <option>Bangalore</option>
                <option>Calicut</option>
                <option>Chennai</option>
                <option>Gujarat</option>
                <option>Guwahati</option>
                <option>Hubballi</option>
                <option>Hyderabad</option>
                <option>Indore</option>
                <option>Kerala</option>
                <option>Kochi</option>
                <option>Kolhapur</option>
                <option>Kolkata</option>
                <option>Kollam</option>
                <option>Kozhikode</option>
                <option>Latur</option>
                <option>Mangaluru</option>
                <option>Mumbai</option>
                <option>Madhya Pradesh</option>
                <option>Nagpur</option>
                <option>Nashik</option>
                <option>Pune</option>
                <option>Sambhaji Nagar</option>
                <option>Solapur</option>
                <option>Thrissur</option>
              </select>
            </div>
          </div>

          {/* Job Cards */}
          {filteredJobs.length > 0 ? (
            filteredJobs.map((job) => (
              <div key={job.id} className="job-card">
                <div className="job-info">
                  <div className="job-logo"></div>
                  <div>
                    <h3 className="job-name">{job.name}</h3>
                    <p className="job-company">{job.company}</p>

                    <div className="job-details">
                      <span>🏨 {job.category}</span>
                      <span>🕒 {job.type}</span>
                      {/* <span>💰 {job.salary}</span> */}
                      <span>📍 {job.location.join(", ")}</span>
                    </div>
                  </div>
                </div>

                {/* Updated Job Details Button */}
                <button
                  className="details-btn"
                  onClick={() => navigate(`/JobsDetails/${job.id}`)}
                >
                  Job Details
                </button>

              </div>
            ))
          ) : (
            <p className="no-jobs">No jobs found for selected filters.</p>
          )}


        </section>
      </div>
    </>
  );
}
